import { Td, Tr } from 'app/components/Table';
import { Skeleton } from '@chakra-ui/react';
import { BaseTableType } from 'app/components/Core/StickyTable/types';
import { getSkeletonSx } from '../LoadingBody/styles';

interface LoadingRowProps<T> {
  columns: Array<T>;
  repeat?: number;
}

export const LoadingRow = <T extends BaseTableType>({
  columns,
  repeat = 3,
}: LoadingRowProps<T>) => {
  return (
    <>
      {Array.from({
        length: repeat,
      }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Tr key={i}>
          {columns.map((column) => (
            <Td key={column.accessorKey} isAvatar={column.isAvatar}>
              {column.isOptions ? (
                <></>
              ) : column.isAvatar ? (
                <Skeleton sx={getSkeletonSx(column)} />
              ) : (
                <Skeleton width="100%" height={6} />
              )}
            </Td>
          ))}
        </Tr>
      ))}
    </>
  );
};
